/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_RolesInputs */

const en_mk_mx_roles = /** @type {(inputs: Mk_Mx_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner, admin and member roles`)
};

const id_mk_mx_roles = /** @type {(inputs: Mk_Mx_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran pemilik, admin, anggota`)
};

/**
* | output |
* | --- |
* | "Owner, admin and member roles" |
*
* @param {Mk_Mx_RolesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_roles = /** @type {((inputs?: Mk_Mx_RolesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_RolesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_roles(inputs)
	return en_mk_mx_roles(inputs)
});